import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  HomeIcon,
  FolderIcon,
  UsersIcon,
  BuildingOfficeIcon,
  BriefcaseIcon,
  CreditCardIcon,
  UserCircleIcon,
  CogIcon,
  ArrowUpOnSquareIcon,
  DocumentTextIcon,
} from '@heroicons/react/24/outline';
import { getuserId } from '../../api/api';
import logo from '../../assets/660.png';
import azero from '../../assets/azero.png';
import { useAuth } from '../../context/AuthProvider';

const Menu = ({ isOpen, toggleMenu }) => {
  const location = useLocation();
  const { user } = useAuth()

  const menuItems = [
    { name: 'Dashboard', icon: <HomeIcon className="w-5 h-5" />, path: '/dashboard', roles: ['super-admin', 'employee'] },
    { name: 'Project', icon: <FolderIcon className="w-5 h-5" />, path: '/project', roles: ['super-admin', 'employee'] },
    { name: 'Customer', icon: <UsersIcon className="w-5 h-5" />, path: '/customer', roles: ['super-admin'] },
    { name: 'Vendor', icon: <BuildingOfficeIcon className="w-5 h-5" />, path: '/vendor', roles: ['super-admin'] },
    { name: 'Employees', icon: <BriefcaseIcon className="w-5 h-5" />, path: '/employee', roles: ['super-admin'] },
    // { name: 'Payment', icon: <CreditCardIcon className="w-5 h-5" />, path: '/payment', roles: ['super-admin'] },
    // { name: 'User Management', icon: <UserCircleIcon className="w-5 h-5" />, path: '/user-management', roles: ['super-admin'] },
    { name: 'Settings', icon: <CogIcon className="w-5 h-5" />, path: '/settings', roles: ['super-admin'] },
    // { name: 'Upload', icon: <ArrowUpOnSquareIcon className="w-5 h-5" />, path: '/upload', roles: ['super-admin'] },
    // { name: 'Invoice', icon: <DocumentTextIcon className="w-5 h-5" />, path: '/invoice', roles: ['super-admin'] },
  ];

  return (
    <div>
      <div className={`${isOpen ? 'block ' : 'hidden '} xl:block lg:block md:block`}>
        <aside className="z-50 fixed w-64 overflow-y-auto scrollbar-custom h-full bg-white shadow-md dark1:bg-gray-800">
          <div className="py-4 text-gray-500 dark1:text-gray-400">
            <div className=" ">
              <img src={logo} alt="logo" className=" h-20 object-cover w-full       " />

            </div>
            <ul className="mt-6">
              {menuItems
                .filter(item => item.roles.includes(user?.role)) // Filter based on user role
                .map(item => (
                  <li
                    key={item.name}
                    className={`relative px-6 py-3 cursor-pointer ${location.pathname === item.path ? 'bg-black text-white' : 'text-gray-800 dark1:text-gray-100'
                      }`}
                  >
                    <Link
                      to={item.path}
                      className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 dark1:hover:text-gray-200"
                      onClick={() => {
                        if (toggleMenu) toggleMenu(); // Close the menu in mobile view
                      }}
                    >
                      {item.icon}
                      <span className="ml-4">{item.name}</span>
                    </Link>
                  </li>
                ))}
            </ul>
          </div>

          {/* Help Card */}
          <div className="p-4 mt-auto">
            <div className="border border-gray-300 text-white bg-black rounded-lg p-6">
              <div className="flex items-start space-x-2 ">
                <img src="https://azerotech.com/assets/AZERO%20LOGO.svg" alt="azero" className="h-12 w-12 my-4 rounded-full border bg-white border-white object-contain" />
                <div>
                  <h2 className="text-md poppins-semibold font-semibold">Need Help?</h2>
                  <p className="text-xs poppins-light text-white">
                    Our team is here to assist you. Feel free to reach out!
                  </p>
                </div>
              </div>
              <div className="mt-6 flex justify-center w-full">
                <a href="https://azerotech.com/">
                  <button className="bg-white poppins-semibold text-black text-sm py-2 px-4 rounded-full   transition duration-200">
                    Contact Us
                  </button>
                </a>
              </div>
            </div>
          </div>
        </aside>
      </div>
    </div>
  );
};

export default Menu;
